import { jsx as _jsx } from "react/jsx-runtime";
const AddressButton = ({ openAddressModal, children, destination }) => {
    return _jsx("button", { type: "button", "aria-label": "Select destination address", className: "navigation-focus-ring-child w-full outline-hidden", onClick: openAddressModal, tabIndex: destination ? 0 : -1, children: children });
};
export default AddressButton;
